import testimonial1 from "../images/testimonial1.webp"
import testimonial2 from "../images/testimonial2.webp"
import testimonial3 from "../images/testimonial3.webp"
import testimonial4 from "../images/testimonial4.webp"

import fiveStar from '../images/5 star rating.png'

const Testimonials = [
    {
      "id": "1",
      "image": testimonial1,
      "rating": fiveStar,
      "testimonial": `Very Convenient, easy use and durable product. Perfect grip with thickness makes it`,
      "testimonialMore": ` look stylish and add class to your kitchen.`,
      "testimonialLink":"https://www.amazon.in/gp/customer-reviews/R375L3ZHHYUP6W/ref=cm_cr_dp_d_rvw_ttl?ie=UTF8&ASIN=B07415SW5M",
      "author": "Author"
    },
    {
      "id": "2",
      "image": testimonial2,
      "rating": fiveStar,
      "testimonial": `I have never ever seen a coaster this good at soaking water. It's so good that when the`,
      "testimonialMore": `water is access, it soaks the water from the sides too so the water never touches my desk. Some coasters have a pattern & some are just dull. Apart from aesthetics, this is one of the best purchases of all time.`,
      "testimonialLink":"https://www.amazon.in/gp/customer-reviews/R3BPIG1CZ147TE",
      "author": "Author"
    },
    {
      "id": "3",
      "image": testimonial3,
      "rating": fiveStar,
      "testimonial": ` Had been waiting to buy a Shivling since quite a few years now. Finally found this one and`,
      "testimonialMore": ` it's the exact Linga I was waiting for! It's just perfect. I kept Him in Pooja room directly once He arrived. it's just Divine.`,
      "testimonialLink":"https://www.amazon.in/gp/customer-reviews/R3IMID7313HVE6",
      "author": "Author"
    },
    {
      "id": "4",
      "image": testimonial4,
      "rating": fiveStar,
      "testimonial": `Looks really classy, very strong, easy to clean, and also has good botton support to `,
      "testimonialMore": `prevrnt slipping. Really worth the money.`,
      "testimonialLink":"https://www.amazon.in/gp/customer-reviews/R7YAQOXP20RZL",
      "author": "Author"
    }
  ]
  

  export default Testimonials